import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../_components/common/Navbar';
import SideNavBar from '../../../_components/common/SideNavBar'
import { orgAdminAreaData } from '../OrgAdminArea/SidebarData'
import UtilityNav from '../../../_components/common/UtilityNav'
import ModalComponent from '../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../_components/common/Table';
import { orgTeam, editOrgTeam } from './formData';
import { orgAdminAction,superAdminAction} from '../../../_actions';

import './index.css'

class OrgTeam extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            orgId: props.match.params.id,
            addTeam: false,
            RemoveTeam: false,
            editTeam: false,
            button_content: null,
            parentOrg: null,
            orgName: null,
            parentOrgId: null,
            teamDetails: '',
            updateModalState: false,
            updateMessage: null,
            navData: [],
            tableData: []
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(this.props.headPerLoadingResonse.data.is_pa_user == true) {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(this.props.headPerLoadingResonse.data.is_org_admin == true) {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(this.props.headPerLoadingResonse.data. is_super_admin == true) {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
        this.props.dispatch(orgAdminAction.getOrgTeamHandler(+id, () => { }))
        this.props.dispatch(superAdminAction.getAnalyticsActiveBatchesHandler(id, () => { }))
    }

    getTeamDetailsById = (id) => {
        const { getOrgTeamsResponse } = this.props;
        const tableData = this.getTableData(getOrgTeamsResponse);
        for (let i = 0; i < tableData.length; i++) {
            if (tableData[i].id === +id) {
                return tableData[i]
            }
        }
    }

    setUpdateModalContent = (data, customData) => {
        this.setState({
            updateModalState: true,
            updateMessage: {
                status: data.status,
                text: `<div className = " text-center">
                <p className = "font-weight-bold h6">${data.status === 200 ? 'Success!' : 'Error!'}</p>
                <p>${data.status === 200 ? customData.successMessage : data.data.message}</p >
                </div> `,
                heading: customData.heading,
                headerColor: data.status === 200 ? `` : `bg-danger`,
                headingIcon: data.status === 200 ? `fa fa-check text-white` : 'fa fa-exclamation-triangle'
            },
        })
    }


    actionSelected(data) {
        const teamDetailsById = this.getTeamDetailsById(data.data.team_id);

        const fd = {
            // 'team_id': data.data.team_id,
            'team_name': data.data.team_name,
            "organisation": teamDetailsById.organisation,
            "batch": +data.data.batch,
            // "team_level": teamDetailsById.team_level,
            "parent_organisation_team": teamDetailsById.id,
            // "batch_id": teamDetailsById.team_type
        }
        this.props.dispatch(orgAdminAction.addOrgTeamHandler(fd, this.state.orgId, (responseData) => {
            const customData = {
                'heading': 'Edit Organisation',
                'successMessage': 'Team Added Successfully'
            }

            this.setUpdateModalContent(responseData, customData);
        }))
    }

    editActionSelected(data) {

        const fd = {
            "team_name": data.data.team_name,
            "parent_organisation_team": data.data.team_id
        }
        this.props.dispatch(orgAdminAction.editOrgTeamHandler(fd, this.state.orgId, this.state.teamDetails.id, (data) => {
            const customData = {
                'heading': 'Edit Team',
                'successMessage': 'Team Updated Successfully'
            }
            this.setUpdateModalContent(data, customData);

        }))
    }

    getTeamLevel = (id) => {
        const tableData = this.state.tableData;
        for (let i = 0; i < tableData.length; i++) {
            if (tableData[i].team_id === +id) {
                return tableData[i].team_level
            }
        }
    }

    toggleEntireTeamModal(showModal) {
        this.setState({
            addTeam: showModal,
            RemoveTeam: showModal,
            editTeam: showModal
        })
    }


    toggleAddTeamModal(showModal) {
        this.setState({
            addTeam: showModal,
        })
        orgTeam.map(
            (data, i) => {
                this.resetData(data)
            }
        )
    }

    resetData(data) {
        data.value = '';
        if (data.validation.required === true) {
            data.valid = false;
        }
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    onClickResponseHandler = (type) => {
        if (type === 'Remove') {
            const fd = {
                "team_id": this.state.teamDetails.id
            }
            this.props.dispatch(orgAdminAction.removeOrgTeamHandler(fd, this.state.orgId, (data) => {
                const customData = {
                    'heading': 'Delete Team',
                    'successMessage': 'Team Deleted Successfully'
                }
                this.setUpdateModalContent(data, customData);

            }))
        }
        this.setState({
            RemoveTeam: false,
        },() => {
            this.props.dispatch({type: "RELOAD_FALSE"})
        })
    }

    toggleTeamEditModal = (showModal) => {
        this.setState({
            addTeam: false,
            RemoveTeam: false,
            parentOrg: 'Organisation_parent',
            orgName: showModal.team_name,
            parentOrgId: showModal.parent_id,
            teamDetails: showModal,
            editTeam: true,
        })
    }


    toggleTeamDeleteModal = (showModal) => {
        this.setState({
            addTeam: false,
            RemoveTeam: true,
            editTeam: false,
            parentOrg: this.getTeamDetailsById(showModal.parent_organisation_team).team_name,
            orgName: showModal.team_name,
            parentOrgId: showModal.parent_id,
            teamDetails: showModal
        })
    }

    getChildrenData = (childrenData, tempData) => {
        for (let j = 0; j < childrenData.length; j++) {
            if (childrenData[j] !== null && childrenData[j].children.length > 0) {
                tempData.push({
                    ...childrenData[j],
                    'buttonDisabled': childrenData[j].is_parent
                })
                this.getChildrenData(childrenData[j].children, tempData)
            }
            if (childrenData[j] !== null && childrenData[j].children.length == 0) {
                tempData.push({
                    ...childrenData[j],
                    'buttonDisabled': childrenData[j].is_parent
                })
            }
        }
    }

    getTableData = (tableData) => {

        let tempData = [];
        for (let i = 0; i < tableData.length; i++) {
            if (tableData[i].children.length > 0) {
                tempData.push({
                    ...tableData[i],
                    'buttonDisabled': tableData[i].is_parent
                })
                this.getChildrenData(tableData[i].children, tempData)
            }
            if (tableData[i].children.length === 0) {
                tempData.push({
                    ...tableData[i],
                    'buttonDisabled': tableData[i].is_parent
                })
            }
        }
        return tempData
    }

    getreformatBatch = (batchData) => {
        let formatedData = []

        for (let i = 0; i < batchData.length; i++) {
            if (batchData[i].active_batches.length > 0) {
                for (let j = 0; j < batchData[i].active_batches.length; j++) {
                    formatedData.push(
                        batchData[i].active_batches[j]
                    )
                }
            }
        }

        return formatedData
    }

    render() {
        const { getOrgTeamsResponse, getOrgTeamsLoading, getAnalyticsActiveBatchesResponse } = this.props;



        const tables = {
            Team: [{
                name: 'Organisation',
                key: 'team_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                headingAlign: false,
                level: 'team_level',
                link: ''
            },
            {
                name: 'Edit',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'iconButton',
                content: 'fa fa-edit fa-custom',
                alignCenter: true,
                headingAlign: true,
                level: 'team_level',
                buttonDisabled: 'buttonDisabled',
                link: '',
                title: 'Edit Team'
            },
            {
                name: 'Remove',
                key: 'REMOVE/DELETE',
                link: '',
                sort: false,
                type: 'iconButton',
                content: 'fas fa-times-circle fas-custom',
                alignCenter: true,
                headingAlign: true,
                level: 'team_level',
                buttonDisabled: 'buttonDisabled',
                link: '',
                title: 'Remove Team'
            }]
        }

        this.state.addTeam === true &&
            orgTeam.map(
                (data, i) => {
                    if (data.key === 'team_id') {
                        data.elementConfig.options = this.getTableData(this.props.getOrgTeamsResponse);
                    }
                    // if (data.key === 'batch') {
                    //     data.elementConfig.options = this.getreformatBatch(this.props.getAnalyticsActiveBatchesResponse);
                    // }
                }
            )

        this.state.editTeam === true &&
            editOrgTeam.map(
                (data, i) => {
                    if (data.key === 'team_id') {
                        data.elementConfig.options = this.getTableData(this.props.getOrgTeamsResponse);
                        data.value = this.state.teamDetails.parent_organisation_team;
                    }
                    else {
                        data.value = this.state.teamDetails[data.key] === 0 ? '' : this.state.teamDetails[data.key];
                    }
                    data.valid = true;
                }
            )

        return (
            <div>
                <Navbar key={this.props.headPerLoadingResonse}  navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={orgAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">Manage Teams</h5>
                        <UtilityNav
                            actionButtons={[
                                {
                                    id: 1,
                                    name: 'Add Team',
                                    toggler: this.toggleAddTeamModal.bind(this),
                                    togglerModal: this.state.addTeam,
                                    icon: 'fa fa-plus fa-custom',
                                    title: 'Add Team'
                                }
                            ]}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        <TableNew
                            data={this.getTableData(getOrgTeamsResponse)}
                            columns={tables.Team}
                            onClickEditIcon={this.toggleTeamEditModal.bind(this)}
                            onClickRemoveorDeleteButton={this.toggleTeamDeleteModal.bind(this)}
                        />
                        {
                            getOrgTeamsLoading === true &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-dark " ></i>
                                &nbsp;loading
                            </p>
                        }
                        {
                            this.state.addTeam &&
                            <ModalComponent
                                showModal={this.state.addTeam}
                                heading="Add Team"
                                formData={orgTeam}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireTeamModal.bind(this)}
                                footerFormSubmitButton={['Add', 'Cancel']}
                                selectKey={['id', 'assessment_batches_id']}
                                selects={['team_name', 'assessment_batches__batch_name']}
                            />
                        }
                        {
                            this.state.editTeam &&
                            <ModalComponent
                                showModal={this.state.editTeam}
                                heading="Edit Team"
                                formData={editOrgTeam}
                                action={this.editActionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireTeamModal.bind(this)}
                                footerFormSubmitButton={['Save', 'Cancel']}
                                selectKey={['id']}
                                selects={['team_name']}
                            />
                        }

                        {
                            this.state.RemoveTeam &&
                            <ModalComponent
                                showModal={this.state.RemoveTeam}
                                heading="Delete Team"
                                toggleEntireModal={this.toggleEntireTeamModal.bind(this)}
                                htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 " >
                                                <p className="">Are you sure you want to remove the team below?</p>
                                                <span>Team Name:</span> <span className='font-weight-bold '>&nbsp;${this.state.orgName}</span>
                                                <br />
                                                <span>Parent Team Name :</span> <span className='font-weight-bold '>&nbsp;${this.state.parentOrg}</span></div > `}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.onClickResponseHandler(type)}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }
                    </div>

                </ div>
            </div >
        );
    }
}

function mapStateToProps(state) {
    const { getOrgTeamsLoading } = state.getOrgTeams;
    const getOrgTeamsError = state.getOrgTeams.error;
    const getOrgTeamsResponse = (!getOrgTeamsLoading && !getOrgTeamsError) ? state.getOrgTeams.data.data.team_list : '';

    // const { getAnalyticsActiveBatchesLoading } = state.getAnalyticsActiveBatchesReducer;
    // const getAnalyticsActiveBatchesError = state.getAnalyticsActiveBatchesReducer.error;
    // const getAnalyticsActiveBatchesResponse = (!getAnalyticsActiveBatchesLoading && !getAnalyticsActiveBatchesError) ? state.getAnalyticsActiveBatchesReducer.data.data.organisation_active_batches : '';

        //Header Permission
        const { headPerLoading } = state.headerPermissionReducer
        const headPerLoadingError = state.headerPermissionReducer.error
        const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    return {
        getOrgTeamsLoading,
        getOrgTeamsResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
        // getAnalyticsActiveBatchesResponse
    }
}

export default connect(mapStateToProps)(OrgTeam);


// WEBPACK FOOTER //
// ./src/_pages/Organzation/OrgAdminArea/OrgTeam.js